import { useTranslation } from 'react-i18next';
import type { JobRole } from '../types';

export const JOB_ROLES: JobRole[] = ['generator', 'pm', 'director', 'screenwriter', 'post'];

interface JobRoleSelectProps {
  value: JobRole;
  disabled?: boolean;
  onChange: (next: JobRole) => void;
  style?: React.CSSProperties;
}

// 岗位下拉(生成师/PM/导演/编剧/后期)。受控组件,保存逻辑由调用方负责。
// 默认全宽 input 样式(表单场景);卡片行内等紧凑场景由调用方传 style 覆盖。
export default function JobRoleSelect({ value, disabled, onChange, style }: JobRoleSelectProps) {
  const { t } = useTranslation('admin');
  return (
    <select
      className="input"
      style={style}
      value={value}
      disabled={disabled}
      onChange={e => onChange(e.target.value as JobRole)}
    >
      {JOB_ROLES.map(r => (
        <option key={r} value={r}>{t(`users.jobRoles.${r}`)}</option>
      ))}
    </select>
  );
}
